import { User } from '@auth0/auth0-react';
import { InputSize } from '@astrumu/ui-library';
import { EmCourse, ProgramAlumniQuery } from '@/graphql/generated';
import { CurrentUser } from '@/apollo/cache/variables';

export interface PredictionFilters {
  years: number;
  majorId?: string;
  purposeId: string;
  subTrackId: string;
  jobRoleId: string;
  isRelocating: boolean;
  currentLocationId: string;
  destinationLocationId: string;
}

export interface DefaultState {
  isPending: boolean;
  isRejected: boolean;
  isFulfilled: boolean;
}

export interface InputProps {
  type: string;
  label: string;
  size: InputSize;
  readOnly?: boolean;
  placeholder: string;
}

export interface ButtonState {
  loading: boolean;
  disabled?: boolean;
}

export interface PredictionParameter {
  title: string;
  checked: boolean;
  filters: Array<keyof PredictionFilters>;
}

export enum DegreeLevel {
  HighSchool = 'high_school',
  Associates = 'associates',
  Bachelors = 'bachelors',
  Masters = 'masters',
  Doctoral = 'doctoral'
}

export type CourseType = 'program' | 'course';

export type Course = Pick<EmCourse, 'id' | 'name' | 'skills'>;
export type CourseWithType = Pick<EmCourse, 'id' | 'name' | 'skills'> & {
  type: CourseType;
};

export interface Auth0User
  extends Omit<User, 'sub'>,
    Pick<CurrentUser, 'email'> {
  sub: string;
}

export type AlumnusWithId = ProgramAlumniQuery['program']['alumni'][number] & {
  id: string;
};
